import { ai as commonjsGlobal, ah as getDefaultExportFromCjs } from "./styleDescriptionDefinitions-BceWyZaI.js";
import { D, d, S, e, f, g, h, i, j, aj, k, l, o, p, q, t, u, v, w, x, y, z, A, B, E, F, H, I, J, K, L, M, N, O, Q, R, U, V, W, X, Y, Z, _, $, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, aa, ac, ad, ae, af, ag } from "./styleDescriptionDefinitions-BceWyZaI.js";
import me, { isTree } from "math-expressions";
import { DEFAULT_MATH_INPUT_FUNCTION_NAMES, buildEffectiveMathInputFunctionNames, isValidMathQuillFunctionName } from "./mathInputFunctionNames.js";
import { D as D2, i as i2, l as l2 } from "./mathjax-loader-ZqTXKt0P.js";
function printDoenetMLrange(position) {
  if (position.start.line === position.end.line) {
    return `line ${position.start.line}`;
  } else {
    return `lines ${position.start.line}–${position.end.line}`;
  }
}
function getLineCharRange(position, allNewlines) {
  let { begin, end } = getBeginEndFromDoenetMLRange(position);
  if (begin === void 0 || end === void 0) {
    return {};
  }
  let { line: lineBegin, character: charBegin } = findLineCharInfo(
    begin,
    allNewlines
  );
  let { line: lineEnd, character: charEnd } = findLineCharInfo(
    end,
    allNewlines
  );
  return { lineBegin, charBegin, lineEnd, charEnd };
}
function getBeginEndFromDoenetMLRange(position) {
  let begin, end;
  if (position) {
    if (position.begin !== void 0) {
      begin = position.begin;
      end = position.end;
    } else if (position.selfCloseBegin !== void 0) {
      begin = position.selfCloseBegin;
      end = position.selfCloseEnd;
    } else if (position.openBegin !== void 0) {
      begin = position.openBegin;
      end = position.closeEnd;
    }
    position.begin = begin;
    position.end = end;
  }
  return { begin, end };
}
function findAllNewlines(inText) {
  let allNewlines = [];
  for (let i3 = 0; i3 < inText.length; i3++) {
    if (inText[i3] == "\n") {
      allNewlines.push(i3 + 1);
    }
  }
  return allNewlines;
}
function findLineCharInfo(pos, allNewlines) {
  for (let i3 = 0; i3 < allNewlines.length; i3++) {
    if (pos <= allNewlines[i3]) {
      if (i3 === 0) {
        return { line: 1, character: pos };
      } else {
        return { line: i3 + 1, character: pos - allNewlines[i3 - 1] };
      }
    }
  }
  return {
    line: allNewlines.length + 1,
    character: pos - (allNewlines[allNewlines.length - 1] || 0)
  };
}
function assignDoenetMLRange(components, position, sourceDoc, init = true) {
  for (let comp of components) {
    if (typeof comp === "object") {
      if (!comp.position || init) {
        comp.position = position;
        comp.sourceDoc = sourceDoc;
      }
      if (comp.children) {
        assignDoenetMLRange(comp.children, position, sourceDoc, false);
      }
      if (comp.attributes) {
        for (let attrName in comp.attributes) {
          let attrComp = comp.attributes[attrName].component;
          if (attrComp) {
            assignDoenetMLRange(
              [attrComp],
              position,
              sourceDoc,
              false
            );
          }
        }
      }
    }
  }
}
function convertDoenetMLAttrRange(position) {
  if (position?.attrBegin) {
    return {
      begin: position.attrBegin,
      end: position.attrEnd
    };
  } else {
    return position;
  }
}
function isErrorRecord(diagnostic) {
  return diagnostic.type === "error";
}
function isWarningRecord(diagnostic) {
  return diagnostic.type === "warning";
}
function isInfoRecord(diagnostic) {
  return diagnostic.type === "info";
}
function isAccessibilityRecord(diagnostic) {
  return diagnostic.type === "accessibility" && (diagnostic.level === 1 || diagnostic.level === 2);
}
function isMacPlatform() {
  const nav = globalThis.navigator;
  if (!nav) {
    return false;
  }
  const platform = nav.userAgentData?.platform ?? nav.platform ?? "";
  return /mac|iphone|ipad|ipod|ios/i.test(platform);
}
function isSaveShortcutKeydown(event) {
  const modifier = isMacPlatform() ? event.metaKey : event.ctrlKey;
  return modifier && !event.altKey && !event.shiftKey && event.code === "KeyS";
}
const COARSE_POINTER_QUERY = "(pointer: coarse)";
function getCoarsePointerQueryList() {
  const matchMedia = globalThis.matchMedia;
  if (typeof matchMedia !== "function") {
    return null;
  }
  return matchMedia(COARSE_POINTER_QUERY);
}
function hasCoarsePrimaryPointer() {
  return getCoarsePointerQueryList()?.matches ?? false;
}
function subscribeToPrimaryPointerType(listener) {
  const queryList = getCoarsePointerQueryList();
  if (!queryList?.addEventListener) {
    return () => {
    };
  }
  queryList.addEventListener("change", listener);
  return () => {
    queryList.removeEventListener?.("change", listener);
  };
}
var base32$1 = { exports: {} };
var hasRequiredBase32;
function requireBase32() {
  if (hasRequiredBase32) return base32$1.exports;
  hasRequiredBase32 = 1;
  (function(module) {
    (function() {
      var root = typeof window === "object" ? window : {};
      var NODE_JS = !root.HI_BASE32_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
      if (NODE_JS) {
        root = commonjsGlobal;
      }
      var COMMON_JS = !root.HI_BASE32_NO_COMMON_JS && true && module.exports;
      var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
      var BASE32_DECODE_CHAR = {
        "A": 0,
        "B": 1,
        "C": 2,
        "D": 3,
        "E": 4,
        "F": 5,
        "G": 6,
        "H": 7,
        "I": 8,
        "J": 9,
        "K": 10,
        "L": 11,
        "M": 12,
        "N": 13,
        "O": 14,
        "P": 15,
        "Q": 16,
        "R": 17,
        "S": 18,
        "T": 19,
        "U": 20,
        "V": 21,
        "W": 22,
        "X": 23,
        "Y": 24,
        "Z": 25,
        "2": 26,
        "3": 27,
        "4": 28,
        "5": 29,
        "6": 30,
        "7": 31
      };
      var blocks = [0, 0, 0, 0, 0, 0, 0, 0];
      var throwInvalidUtf8 = function(position, partial) {
        if (partial.length > 10) {
          partial = "..." + partial.substr(-10);
        }
        var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position + " bytes: " + partial + " <-");
        err.position = position;
        throw err;
      };
      var toUtf8String = function(bytes) {
        var str = "", length = bytes.length, i3 = 0, followingChars = 0, b, c;
        while (i3 < length) {
          b = bytes[i3++];
          if (b <= 127) {
            str += String.fromCharCode(b);
            continue;
          } else if (b > 191 && b <= 223) {
            c = b & 31;
            followingChars = 1;
          } else if (b <= 239) {
            c = b & 15;
            followingChars = 2;
          } else if (b <= 247) {
            c = b & 7;
            followingChars = 3;
          } else {
            throwInvalidUtf8(i3, str);
          }
          for (var j2 = 0; j2 < followingChars; ++j2) {
            b = bytes[i3++];
            if (b < 128 || b > 191) {
              throwInvalidUtf8(i3, str);
            }
            c <<= 6;
            c += b & 63;
          }
          if (c >= 55296 && c <= 57343) {
            throwInvalidUtf8(i3, str);
          }
          if (c > 1114111) {
            throwInvalidUtf8(i3, str);
          }
          if (c <= 65535) {
            str += String.fromCharCode(c);
          } else {
            c -= 65536;
            str += String.fromCharCode((c >> 10) + 55296);
            str += String.fromCharCode((c & 1023) + 56320);
          }
        }
        return str;
      };
      var decodeAsBytes = function(base32Str) {
        if (base32Str === "") {
          return [];
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        base32Str = base32Str.replace(/=/g, "");
        var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index = 0, length = base32Str.length;
        for (var i3 = 0, count = length >> 3 << 3; i3 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
          bytes[index++] = (v7 << 5 | v8) & 255;
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
        }
        return bytes;
      };
      var encodeAscii = function(str) {
        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
        for (var i3 = 0, count = parseInt(length / 5) * 5; i3 < count; ) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3++);
          v4 = str.charCodeAt(i3++);
          v5 = str.charCodeAt(i3++);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3++);
          v4 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encodeUtf8 = function(str) {
        var v1, v2, v3, v4, v5, code, end = false, base32Str = "", index = 0, i3, start = 0, length = str.length;
        if (str === "") {
          return base32Str;
        }
        do {
          blocks[0] = blocks[5];
          blocks[1] = blocks[6];
          blocks[2] = blocks[7];
          for (i3 = start; index < length && i3 < 5; ++index) {
            code = str.charCodeAt(index);
            if (code < 128) {
              blocks[i3++] = code;
            } else if (code < 2048) {
              blocks[i3++] = 192 | code >> 6;
              blocks[i3++] = 128 | code & 63;
            } else if (code < 55296 || code >= 57344) {
              blocks[i3++] = 224 | code >> 12;
              blocks[i3++] = 128 | code >> 6 & 63;
              blocks[i3++] = 128 | code & 63;
            } else {
              code = 65536 + ((code & 1023) << 10 | str.charCodeAt(++index) & 1023);
              blocks[i3++] = 240 | code >> 18;
              blocks[i3++] = 128 | code >> 12 & 63;
              blocks[i3++] = 128 | code >> 6 & 63;
              blocks[i3++] = 128 | code & 63;
            }
          }
          start = i3 - 5;
          if (index === length) {
            ++index;
          }
          if (index > length && i3 < 6) {
            end = true;
          }
          v1 = blocks[0];
          if (i3 > 4) {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            v5 = blocks[4];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
          } else if (i3 === 1) {
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
          } else if (i3 === 2) {
            v2 = blocks[1];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
          } else if (i3 === 3) {
            v2 = blocks[1];
            v3 = blocks[2];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
          } else {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
          }
        } while (!end);
        return base32Str;
      };
      var encodeBytes = function(bytes) {
        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
        for (var i3 = 0, count = parseInt(length / 5) * 5; i3 < count; ) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3++];
          v4 = bytes[i3++];
          v5 = bytes[i3++];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = bytes[i3++];
          v2 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3++];
          v4 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encode = function(input, asciiOnly) {
        var notString = typeof input !== "string";
        if (notString && input.constructor === ArrayBuffer) {
          input = new Uint8Array(input);
        }
        if (notString) {
          return encodeBytes(input);
        } else if (asciiOnly) {
          return encodeAscii(input);
        } else {
          return encodeUtf8(input);
        }
      };
      var decode = function(base32Str, asciiOnly) {
        if (!asciiOnly) {
          return toUtf8String(decodeAsBytes(base32Str));
        }
        if (base32Str === "") {
          return "";
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
        if (length === -1) {
          length = base32Str.length;
        }
        for (var i3 = 0, count = length >> 3 << 3; i3 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
        }
        return str;
      };
      var exports = {
        encode,
        decode
      };
      decode.asBytes = decodeAsBytes;
      if (COMMON_JS) {
        module.exports = exports;
      } else {
        root.base32 = exports;
      }
    })();
  })(base32$1);
  return base32$1.exports;
}
var base32Exports = requireBase32();
const base32 = /* @__PURE__ */ getDefaultExportFromCjs(base32Exports);
async function cidFromText(text) {
  let encoder = new TextEncoder();
  let data = encoder.encode(text);
  return await cidFromArrayBuffer(data);
}
let digest = null;
async function cidFromArrayBuffer(data) {
  if (!digest) {
    try {
      await crypto.subtle.digest("SHA-256", new Uint8Array());
      digest = (data2) => crypto.subtle.digest("SHA-256", data2);
    } catch (e2) {
      const sha256 = (await import("./sha256-DT5xJ2Hv.js").then((n) => n.s)).default;
      digest = (data2) => sha256(data2, {
        asBytes: true
      });
    }
  }
  let hashBuffer = await digest(data);
  let cidArray = new Uint8Array(36);
  cidArray.set([1, 85, 18, 32]);
  cidArray.set(new Uint8Array(hashBuffer), 4);
  let cid = "b" + base32.encode(cidArray).toLowerCase().replace(/=+/, "");
  return cid;
}
const textByCid = {};
function retrieveTextFileForCid(cid, ext = "doenet") {
  if (textByCid[cid] !== void 0) {
    return Promise.resolve(textByCid[cid]);
  }
  let resultServer = retrieveTextFileFromServer(cid, ext);
  return resultServer.promise.then((res) => {
    textByCid[cid] = res;
    return res;
  });
}
function retrieveTextFileFromServer(cid, ext) {
  let controller = new AbortController();
  let signal = controller.signal;
  let retrieveFromServer = async function() {
    try {
      let response = await fetch(`/media/${cid}.${ext}`, { signal });
      if (response.ok) {
        let doenetML = await response.text();
        let CidRetrieved = await cidFromText(doenetML);
        if (CidRetrieved === cid) {
          return doenetML;
        } else {
          console.warn(`cid mismatch, ${cid}, ${CidRetrieved}`);
          return Promise.reject(new Error("cid mismatch"));
        }
      } else {
        return Promise.reject(new Error(`cid not found: ${cid}`));
      }
    } catch (e2) {
      return Promise.reject(new Error(`cid not found: ${cid}`));
    }
  };
  let promise = retrieveFromServer();
  return { promise, controller };
}
function isSubset(obj) {
  return obj instanceof Constructors.InvalidSet || obj instanceof Constructors.EmptySet || obj instanceof Constructors.RealLine || obj instanceof Constructors.Singleton || obj instanceof Constructors.OpenInterval || obj instanceof Constructors.Union;
}
const genericMethods = {
  union: function(A2, B2) {
    return A2.complement().intersect(B2.complement()).complement();
  },
  intersectWithOpenInterval: function(A2, B2) {
    return A2.intersect(B2);
  },
  setMinus: function(A2, B2) {
    return A2.intersect(B2.complement());
  },
  symmetricDifference: function(A2, B2) {
    return A2.setMinus(B2).union(B2.setMinus(A2));
  },
  containsSubset: function(A2, B2) {
    return A2.intersect(B2).equals(B2);
  },
  isSubsetOf: function(A2, B2) {
    return genericMethods.containsSubset(B2, A2);
  },
  equals: function(A2, B2) {
    return A2.symmetricDifference(B2).isEmpty();
  }
};
function subsetReviver(_key, value) {
  if (typeof value === "object" && value !== null && "objectType" in value && value.objectType === "subset" && "data" in value && typeof value.data === "object" && value.data !== null && "type" in value.data && value.data.type !== void 0) {
    if (value.data.type === "empty") {
      return EmptySet();
    } else if (value.data.type === "realLine") {
      return RealLine();
    } else if (value.data.type === "singleton") {
      if ("element" in value.data && typeof value.data.element === "number") {
        return Singleton(value.data.element);
      }
    } else if (value.data.type === "union") {
      if ("subsets" in value.data && Array.isArray(value.data.subsets) && value.data.subsets.every(
        (s) => s instanceof Constructors.Singleton || s instanceof Constructors.OpenInterval
      )) {
        return Union(value.data.subsets);
      }
    } else if (value.data.type === "openInterval") {
      if ("left" in value.data && typeof value.data.left === "number" && "right" in value.data && typeof value.data.right === "number") {
        return OpenInterval(value.data.left, value.data.right);
      }
    }
  }
  return value;
}
const Constructors = {
  EmptySet: class {
    constructor() {
      this.type = "empty";
    }
    union(that) {
      return that;
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    intersect() {
      return EmptySet();
    }
    containsElement() {
      return false;
    }
    isEmpty() {
      return true;
    }
    complement() {
      return RealLine();
    }
    isValid() {
      return true;
    }
    toString() {
      return "∅";
    }
    toMathExpression() {
      return me.fromAst("emptyset");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "empty" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  InvalidSet: class {
    constructor() {
      this.type = "invalid";
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    union() {
      return InvalidSet();
    }
    intersect() {
      return InvalidSet();
    }
    containsElement() {
      return false;
    }
    isEmpty() {
      return true;
    }
    complement() {
      return InvalidSet();
    }
    isValid() {
      return false;
    }
    toString() {
      return "＿";
    }
    toMathExpression() {
      return me.fromAst("＿");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "invalid" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  RealLine: class {
    constructor() {
      this.type = "realLine";
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    union() {
      return RealLine();
    }
    intersect(that) {
      return that;
    }
    containsElement() {
      return true;
    }
    complement() {
      return EmptySet();
    }
    isEmpty() {
      return false;
    }
    toString() {
      return "ℝ";
    }
    toMathExpression() {
      return me.fromAst("R");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "realLine" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  Singleton: class {
    constructor(element) {
      this.type = "singleton";
      this.element = element;
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    union(that) {
      if (that.containsElement(this.element)) {
        return that;
      } else {
        return Union([that, this]);
      }
    }
    intersect(subset) {
      if (subset.containsElement(this.element)) {
        return Singleton(this.element);
      } else {
        return EmptySet();
      }
    }
    isEmpty() {
      return false;
    }
    containsElement(element) {
      return element === this.element;
    }
    complement() {
      return Union([
        OpenInterval(-Infinity, this.element),
        OpenInterval(this.element, Infinity)
      ]);
    }
    toString() {
      return `{${this.element}}`;
    }
    toMathExpression() {
      return me.fromAst(["set", this.element]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "singleton", element: this.element }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  OpenInterval: class {
    constructor(left, right) {
      this.type = "openInterval";
      this.left = left;
      this.right = right;
    }
    union(that) {
      return genericMethods.union(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    intersect(subset) {
      return subset.intersectWithOpenInterval(this);
    }
    intersectWithOpenInterval(that) {
      return OpenInterval(
        Math.max(this.left, that.left),
        Math.min(this.right, that.right)
      );
    }
    complement() {
      return Union([
        OpenClosedInterval(-Infinity, this.left),
        ClosedOpenInterval(this.right, Infinity)
      ]);
    }
    isEmpty() {
      return this.left >= this.right;
    }
    containsElement(element) {
      return element > this.left && element < this.right;
    }
    toString() {
      return `(${this.left.toString()},${this.right.toString()})`;
    }
    toMathExpression() {
      return me.fromAst([
        "interval",
        ["tuple", this.left, this.right],
        ["tuple", false, false]
      ]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: {
          type: "openInterval",
          left: this.left,
          right: this.right
        }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  Union: class {
    constructor(subsets) {
      this.type = "union";
      this.subsets = subsets;
    }
    union(that) {
      return genericMethods.union(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    intersectWithOpenInterval(that) {
      return this.intersect(that);
    }
    containsElement(element) {
      return this.subsets.some((s) => s.containsElement(element));
    }
    isEmpty() {
      return this.subsets.every((s) => s.isEmpty());
    }
    complement() {
      return this.subsets.map((s) => s.complement()).reduce((a, b) => a.intersect(b));
    }
    intersect(subset) {
      return Union(this.subsets.map((s) => subset.intersect(s)));
    }
    toString() {
      return this.subsets.map((s) => s.toString()).join(" U ");
    }
    toMathExpression() {
      return me.fromAst([
        "union",
        ...this.subsets.map((s) => s.toMathExpression().tree)
      ]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: {
          type: "union",
          subsets: this.subsets.map((s) => s.toJSON())
        }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  }
};
function EmptySet() {
  return new Constructors.EmptySet();
}
function InvalidSet() {
  return new Constructors.InvalidSet();
}
function RealLine() {
  return new Constructors.RealLine();
}
function Singleton(element) {
  if (!Number.isFinite(element)) {
    return new Constructors.EmptySet();
  }
  return new Constructors.Singleton(element);
}
function OpenInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    return new Constructors.OpenInterval(left, right);
  }
}
function Union(subsets) {
  if (subsets.some((s) => s.type === "invalid")) {
    return new Constructors.InvalidSet();
  }
  const flattenedSubsets = subsets.reduce(
    (acc, val) => val.type === "union" ? [...acc, ...val.subsets] : [...acc, val],
    []
  );
  const filtered = [];
  for (const sub of flattenedSubsets) {
    if (sub.type === "realLine") {
      return new Constructors.RealLine();
    } else if (sub.type !== "empty" && !sub.isEmpty()) {
      filtered.push(sub);
    }
  }
  if (filtered.length === 0) {
    return new Constructors.EmptySet();
  }
  const newSubsets = [];
  for (let ind1 = 0; ind1 < filtered.length; ind1++) {
    let sub1 = filtered[ind1];
    let addSub1 = true;
    if (sub1.type === "openInterval") {
      let left = sub1.left;
      let right = sub1.right;
      for (let ind2 = ind1 + 1; ind2 < filtered.length; ind2++) {
        let sub2 = filtered[ind2];
        if (sub2.type === "openInterval") {
          if (left < sub2.right && sub2.left < right) {
            left = Math.min(left, sub2.left);
            right = Math.max(right, sub2.right);
            filtered.splice(ind2, 1);
            ind2--;
            addSub1 = false;
            ind1--;
            break;
          } else if (left === sub2.right || right === sub2.left) {
            let gap = left === sub2.right ? left : right;
            let foundSingleton = false;
            for (let ind3 = 0; ind3 < newSubsets.length; ind3++) {
              let sub3 = newSubsets[ind3];
              if (sub3.type === "singleton" && sub3.element === gap) {
                newSubsets.splice(ind3, 1);
                foundSingleton = true;
                break;
              }
            }
            if (!foundSingleton) {
              for (let ind3 = ind1 + 1; ind3 < filtered.length; ind3++) {
                let sub3 = filtered[ind3];
                if (sub3.type === "singleton" && sub3.element === gap) {
                  filtered.splice(ind3, 1);
                  foundSingleton = true;
                  if (ind3 < ind2) {
                    ind2--;
                  }
                  break;
                }
              }
            }
            if (foundSingleton) {
              left = Math.min(left, sub2.left);
              right = Math.max(right, sub2.right);
              filtered.splice(ind2, 1);
              ind2--;
              addSub1 = false;
              ind1--;
              break;
            }
          }
        } else {
          if (sub2.element > left && sub2.element < right) {
            filtered.splice(ind2, 1);
            ind2--;
          }
        }
      }
      sub1.left = left;
      sub1.right = right;
      if (sub1.left === -Infinity && sub1.right === Infinity) {
        return new Constructors.RealLine();
      }
    } else {
      let val = sub1.element;
      for (let ind2 = ind1 + 1; ind2 < filtered.length; ind2++) {
        let sub2 = filtered[ind2];
        if (sub2.type === "openInterval") {
          if (val > sub2.left && val < sub2.right) {
            filtered.splice(ind1, 1);
            ind1--;
            addSub1 = false;
            break;
          }
        } else if (sub2.element === val) {
          filtered.splice(ind2, 1);
          ind2--;
        }
      }
    }
    if (addSub1) {
      newSubsets.push(sub1);
    }
  }
  if (newSubsets.length === 1) {
    return newSubsets[0];
  }
  return new Constructors.Union(newSubsets);
}
function ClosedInterval(left, right) {
  if (!(left <= right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    const pieces = [
      new Constructors.OpenInterval(left, right)
    ];
    if (Number.isFinite(left)) {
      pieces.push(new Constructors.Singleton(left));
    }
    if (Number.isFinite(right)) {
      pieces.push(new Constructors.Singleton(right));
    }
    return Union(pieces);
  }
}
function OpenClosedInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    const pieces = [
      new Constructors.OpenInterval(left, right)
    ];
    if (Number.isFinite(right)) {
      pieces.push(new Constructors.Singleton(right));
    }
    return Union(pieces);
  }
}
function ClosedOpenInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    const pieces = [
      new Constructors.OpenInterval(left, right)
    ];
    if (Number.isFinite(left)) {
      pieces.push(new Constructors.Singleton(left));
    }
    return Union(pieces);
  }
}
const subsetOfReals = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClosedInterval,
  ClosedOpenInterval,
  EmptySet,
  InvalidSet,
  OpenClosedInterval,
  OpenInterval,
  RealLine,
  Singleton,
  Union,
  isSubset,
  subsetReviver
}, Symbol.toStringTag, { value: "Module" }));
function deepClone(obj, BaseComponent, hash) {
  if (Object(obj) !== obj || obj instanceof Function) return obj;
  if (BaseComponent !== void 0 && obj instanceof BaseComponent) return obj;
  if (obj instanceof me.class || isSubset(obj)) {
    return obj.copy();
  }
  if (hash === void 0) {
    hash = /* @__PURE__ */ new WeakMap();
  }
  if (Array.isArray(obj)) {
    return [...obj.map((x2) => deepClone(x2, BaseComponent, hash))];
  }
  if (obj.constructor === Object && Object.entries(obj).length === 0) {
    return {};
  }
  if (hash.has(obj)) return hash.get(obj);
  let result;
  try {
    result = new obj.constructor();
  } catch (e2) {
    result = Object.create(Object.getPrototypeOf(obj));
  }
  if (obj instanceof Map) {
    Array.from(
      obj,
      ([key, val]) => result.set(
        deepClone(key, BaseComponent, hash),
        deepClone(val, BaseComponent, hash)
      )
    );
  } else if (obj instanceof Set) {
    Array.from(
      obj,
      (key) => result.add(deepClone(key, BaseComponent, hash))
    );
  }
  hash.set(obj, result);
  return Object.assign(
    result,
    ...Object.keys(obj).map((key) => ({
      [key]: deepClone(obj[key], BaseComponent, hash)
    }))
  );
}
function deepCompare(a, b, BaseComponent) {
  let leftChain = [];
  let rightChain = [];
  function compare2Objects(x2, y2) {
    let p2;
    if (Number.isNaN(x2) && Number.isNaN(y2)) {
      return true;
    }
    if (x2 === y2) {
      return true;
    }
    if (BaseComponent !== void 0 && x2 instanceof BaseComponent && y2 instanceof BaseComponent) {
      return x2.componentIdx === y2.componentIdx;
    }
    if (x2 instanceof me.class && y2 instanceof me.class) {
      return compare2Objects(x2.tree, y2.tree);
    }
    if (typeof x2 === "function" && typeof y2 === "function" || x2 instanceof Date && y2 instanceof Date || x2 instanceof RegExp && y2 instanceof RegExp || x2 instanceof String && y2 instanceof String || x2 instanceof Number && y2 instanceof Number) {
      return x2.toString() === y2.toString();
    }
    if (!(x2 instanceof Object && y2 instanceof Object)) {
      return false;
    }
    if (x2.isPrototypeOf(y2) || y2.isPrototypeOf(x2)) {
      return false;
    }
    if (x2.constructor !== y2.constructor) {
      return false;
    }
    if (x2.prototype !== y2.prototype) {
      return false;
    }
    if (leftChain.indexOf(x2) > -1 || rightChain.indexOf(y2) > -1) {
      return false;
    }
    for (p2 in y2) {
      if (y2.hasOwnProperty(p2) !== x2.hasOwnProperty(p2)) {
        return false;
      } else if (typeof y2[p2] !== typeof x2[p2]) {
        return false;
      }
    }
    for (p2 in x2) {
      if (y2.hasOwnProperty(p2) !== x2.hasOwnProperty(p2)) {
        return false;
      } else if (typeof y2[p2] !== typeof x2[p2]) {
        return false;
      }
      switch (typeof x2[p2]) {
        case "object":
        case "function":
          leftChain.push(x2);
          rightChain.push(y2);
          if (!compare2Objects(x2[p2], y2[p2])) {
            return false;
          }
          leftChain.pop();
          rightChain.pop();
          break;
        default:
          if (x2[p2] !== y2[p2] && !(Number.isNaN(x2[p2]) && Number.isNaN(y2[p2]))) {
            return false;
          }
          break;
      }
    }
    return true;
  }
  return compare2Objects(a, b);
}
function serializedComponentsReplacer(key, value) {
  if (value !== value) {
    return { objectType: "special-numeric", stringValue: "NaN" };
  } else if (value === Infinity) {
    return { objectType: "special-numeric", stringValue: "Infinity" };
  } else if (value === -Infinity) {
    return { objectType: "special-numeric", stringValue: "-Infinity" };
  }
  return value;
}
function nanInfinityReviver(key, value) {
  if (value && value.objectType === "special-numeric") {
    if (value.stringValue === "NaN") {
      return NaN;
    } else if (value.stringValue === "Infinity") {
      return Infinity;
    } else if (value.stringValue === "-Infinity") {
      return -Infinity;
    }
  }
  return value;
}
function serializedComponentsReviver(key, value) {
  return me.reviver(key, subsetReviver(key, nanInfinityReviver(key, value)));
}
function buildSubsetFromIntervals(tree, variable) {
  if (!Array.isArray(tree)) {
    if (Number.isFinite(tree)) {
      return Singleton(tree);
    } else if (tree === "R") {
      return RealLine();
    } else if (tree === "emptyset") {
      return EmptySet();
    } else {
      return InvalidSet();
    }
  }
  let operator = tree[0];
  if (operator === "interval") {
    let endpoints = tree[1];
    let closed = tree[2];
    let left = endpoints[1];
    if (!Number.isFinite(left)) {
      left = me.fromAst(left).evaluate_to_constant();
      if (!(Number.isFinite(left) || left === Infinity || left === -Infinity)) {
        return InvalidSet();
      }
    }
    let right = endpoints[2];
    if (!Number.isFinite(right)) {
      right = me.fromAst(right).evaluate_to_constant();
      if (!(Number.isFinite(right) || right === Infinity || right === -Infinity)) {
        return InvalidSet();
      }
    }
    if (closed[1]) {
      if (closed[2]) {
        return ClosedInterval(left, right);
      } else {
        return ClosedOpenInterval(left, right);
      }
    } else {
      if (closed[2]) {
        return OpenClosedInterval(left, right);
      } else {
        return OpenInterval(left, right);
      }
    }
  } else if (operator === "union" || operator === "or" || operator === "set" || operator === "list") {
    let pieces = tree.slice(1).map((x2) => buildSubsetFromIntervals(x2, variable)).filter((x2) => x2);
    if (pieces.length === 0) {
      return EmptySet();
    } else if (pieces.length === 1) {
      return pieces[0];
    } else {
      return Union(pieces);
    }
  } else if (operator === "intersect" || operator === "and") {
    let pieces = tree.slice(1).map((x2) => buildSubsetFromIntervals(x2, variable)).filter((x2) => x2);
    if (pieces.length === 0) {
      return RealLine();
    } else {
      return pieces.reduce((a, c) => a.intersect(c));
    }
  } else if (["<", "le", ">", "ge", "=", "ne"].includes(operator)) {
    let left = tree[1];
    let varAtLeft = false;
    if (!Number.isFinite(left)) {
      if (deepCompare(left, variable)) {
        varAtLeft = true;
      } else {
        left = me.fromAst(left).evaluate_to_constant();
        if (!(Number.isFinite(left) || left === Infinity || left === -Infinity)) {
          return InvalidSet();
        }
      }
    }
    let right = tree[2];
    let varAtRight = false;
    if (!Number.isFinite(right)) {
      if (deepCompare(right, variable)) {
        varAtRight = true;
      } else {
        right = me.fromAst(right).evaluate_to_constant();
        if (!(Number.isFinite(right) || right === Infinity || right === -Infinity)) {
          return InvalidSet();
        }
      }
    }
    if (varAtLeft) {
      if (varAtRight) {
        return InvalidSet();
      } else {
        if (operator === "<") {
          return OpenInterval(-Infinity, right);
        } else if (operator === "le") {
          return OpenClosedInterval(-Infinity, right);
        } else if (operator === ">") {
          return OpenInterval(right, Infinity);
        } else if (operator === "ge") {
          return ClosedOpenInterval(right, Infinity);
        } else if (operator === "=") {
          if (Number.isFinite(right)) {
            return Singleton(right);
          } else {
            return EmptySet();
          }
        } else {
          if (Number.isFinite(right)) {
            return Union([
              OpenInterval(-Infinity, right),
              OpenInterval(right, Infinity)
            ]);
          } else {
            return RealLine();
          }
        }
      }
    } else {
      if (varAtRight) {
        if (operator === "<") {
          return OpenInterval(left, Infinity);
        } else if (operator === "le") {
          return ClosedOpenInterval(left, Infinity);
        } else if (operator === ">") {
          return OpenInterval(-Infinity, left);
        } else if (operator === "ge") {
          return OpenClosedInterval(-Infinity, left);
        } else if (operator === "=") {
          if (Number.isFinite(left)) {
            return Singleton(left);
          } else {
            return EmptySet();
          }
        } else {
          if (Number.isFinite(left)) {
            return Union([
              OpenInterval(-Infinity, left),
              OpenInterval(left, Infinity)
            ]);
          } else {
            return RealLine();
          }
        }
      } else {
        return InvalidSet();
      }
    }
  } else if (["lts", "gts"].includes(operator)) {
    let vals = tree[1].slice(1);
    let strict = tree[2].slice(1);
    if (vals.length !== 3 || !deepCompare(vals[1], variable)) {
      return InvalidSet();
    }
    if (operator === "gts") {
      vals.reverse();
      strict.reverse();
    }
    let left = vals[0];
    if (!Number.isFinite(left)) {
      left = me.fromAst(left).evaluate_to_constant();
      if (!(Number.isFinite(left) || left === Infinity || left === -Infinity)) {
        return InvalidSet();
      }
    }
    let right = vals[2];
    if (!Number.isFinite(right)) {
      right = me.fromAst(right).evaluate_to_constant();
      if (!(Number.isFinite(right) || right === Infinity || right === -Infinity)) {
        return InvalidSet();
      }
    }
    if (strict[0]) {
      if (strict[1]) {
        return OpenInterval(left, right);
      } else {
        return OpenClosedInterval(left, right);
      }
    } else {
      if (strict[1]) {
        return ClosedOpenInterval(left, right);
      } else {
        return ClosedInterval(left, right);
      }
    }
  } else if (operator === "|") {
    let x2 = tree[1];
    return buildSubsetFromIntervals(tree[2], x2);
  } else if (operator === "^" && (tree[2] === "C" || tree[2] === "c")) {
    let orig = buildSubsetFromIntervals(tree[1], variable);
    return orig.complement();
  } else if (operator === "in") {
    if (deepCompare(tree[1], variable)) {
      return buildSubsetFromIntervals(tree[2], variable);
    } else {
      return InvalidSet();
    }
  } else if (operator === "ni") {
    if (deepCompare(tree[2], variable)) {
      return buildSubsetFromIntervals(tree[1], variable);
    } else {
      return InvalidSet();
    }
  } else if (operator === "notin") {
    if (deepCompare(tree[1], variable)) {
      let orig = buildSubsetFromIntervals(tree[2], variable);
      return orig.complement();
    }
    return InvalidSet();
  } else if (operator === "notni") {
    if (deepCompare(tree[2], variable)) {
      let orig = buildSubsetFromIntervals(tree[1], variable);
      return orig.complement();
    }
    return InvalidSet();
  } else {
    let num = me.fromAst(tree).evaluate_to_constant();
    if (typeof num === "number" && Number.isFinite(num)) {
      return Singleton(num);
    } else {
      return InvalidSet();
    }
  }
}
function buildSubsetFromMathExpression(expr, variable) {
  return buildSubsetFromIntervals(expr.to_intervals().tree, variable?.tree);
}
function mathExpressionFromSubsetValue({
  subsetValue,
  variable,
  displayMode = "intervals"
}) {
  function subsetToMath(subset) {
    if (subset === null) {
      return "＿";
    }
    if (displayMode === "intervals") {
      if (subset.type === "closedInterval") {
        return [
          "interval",
          ["tuple", subset.left, subset.right],
          ["tuple", true, true]
        ];
      } else if (subset.type === "openClosedInterval") {
        return [
          "interval",
          ["tuple", subset.left, subset.right],
          ["tuple", false, true]
        ];
      } else if (subset.type === "closedOpenInterval") {
        return [
          "interval",
          ["tuple", subset.left, subset.right],
          ["tuple", true, false]
        ];
      } else {
        return subset.toMathExpression().tree;
      }
    } else {
      if (subset.type === "closedInterval") {
        return [
          "lts",
          ["tuple", subset.left, variable, subset.right],
          ["tuple", false, false]
        ];
      } else if (subset.type === "openClosedInterval") {
        if (subset.left === -Infinity) {
          return ["le", variable, subset.right];
        } else {
          return [
            "lts",
            ["tuple", subset.left, variable, subset.right],
            ["tuple", true, false]
          ];
        }
      } else if (subset.type === "closedOpenInterval") {
        if (subset.right === Infinity) {
          return ["ge", variable, subset.left];
        } else {
          return [
            "lts",
            ["tuple", subset.left, variable, subset.right],
            ["tuple", false, true]
          ];
        }
      } else if (subset.type === "openInterval") {
        if (subset.left === -Infinity) {
          return ["<", variable, subset.right];
        } else if (subset.right === Infinity) {
          return [">", variable, subset.left];
        } else {
          return [
            "lts",
            ["tuple", subset.left, variable, subset.right],
            ["tuple", true, true]
          ];
        }
      } else if (subset.type === "singleton") {
        return ["=", variable, subset.element];
      } else if (!subset.isValid()) {
        return "＿";
      } else if (subset.isEmpty()) {
        return ["in", variable, "emptyset"];
      } else if (subset.type === "realLine") {
        return ["in", variable, "R"];
      } else {
        return "＿";
      }
    }
  }
  let expression;
  let mathSubsets = mergeIntervals(subsetValue).map((x2) => subsetToMath(x2));
  if (mathSubsets.length > 1) {
    if (displayMode === "intervals") {
      expression = me.fromAst(["union", ...mathSubsets]);
    } else {
      expression = me.fromAst(["or", ...mathSubsets]);
    }
  } else {
    expression = me.fromAst(mathSubsets[0]);
  }
  return expression;
}
function mergeIntervals(subsetValue) {
  if (subsetValue.type === "union") {
    let singletons = subsetValue.subsets.filter(
      (x2) => x2.type === "singleton"
    );
    let intervals = subsetValue.subsets.filter(
      (x2) => x2.type === "openInterval"
    );
    for (let ind1 = 0; ind1 < singletons.length; ind1++) {
      let x2 = singletons[ind1].element;
      for (let ind2 = 0; ind2 < intervals.length; ind2++) {
        let interval = intervals[ind2];
        if (x2 === interval.left) {
          if (interval.type === "openClosedInterval") {
            interval = {
              type: "closedInterval",
              left: interval.left,
              right: interval.right
            };
          } else {
            interval = {
              type: "closedOpenInterval",
              left: interval.left,
              right: interval.right
            };
          }
          intervals.splice(ind2, 1, interval);
          singletons.splice(ind1, 1);
          ind1--;
        } else if (x2 === interval.right) {
          if (interval.type === "closedOpenInterval") {
            interval = {
              type: "closedInterval",
              left: interval.left,
              right: interval.right
            };
          } else {
            interval = {
              type: "openClosedInterval",
              left: interval.left,
              right: interval.right
            };
          }
          intervals.splice(ind2, 1, interval);
          singletons.splice(ind1, 1);
          ind1--;
        }
      }
    }
    return [...intervals, ...singletons].sort(
      (a, b) => (a.type === "singleton" ? a.element : a.left) - (b.type === "singleton" ? b.element : b.left)
    );
  } else {
    return [subsetValue];
  }
}
function find_effective_domain({
  domain,
  truncateToFiniteDomain = false,
  xscale = 1
}) {
  let minx = -Infinity;
  let maxx = Infinity;
  let openMin = true, openMax = true;
  if (domain !== null) {
    let domain1 = domain[0];
    if (domain1 !== void 0) {
      minx = me.fromAst(domain1.tree[1][1]).evaluate_to_constant();
      if (!Number.isFinite(minx)) {
        minx = -Infinity;
      } else {
        openMin = !domain1.tree[2][1];
      }
      maxx = me.fromAst(domain1.tree[1][2]).evaluate_to_constant();
      if (!Number.isFinite(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !domain1.tree[2][2];
      }
    }
  }
  if (truncateToFiniteDomain) {
    if (minx === -Infinity) {
      if (maxx === Infinity) {
        minx = -100 * xscale;
        maxx = 100 * xscale;
      } else {
        minx = maxx - 200 * xscale;
      }
    } else if (maxx === Infinity) {
      maxx = minx + 200 * xscale;
    }
  } else {
    if (minx === -Infinity) {
      openMin = false;
    }
    if (maxx === Infinity) {
      openMax = false;
    }
  }
  return { minx, maxx, openMin, openMax };
}
function find_effective_domains_piecewise_children({
  domain,
  numericalDomainsOfChildren
}) {
  let domainUnused;
  if (domain) {
    let domainMin = me.fromAst(domain[0].tree[1][1]).evaluate_to_constant();
    let domainMax = me.fromAst(domain[0].tree[1][2]).evaluate_to_constant();
    if (Number.isNaN(domainMin) || Number.isNaN(domainMax)) {
      domainUnused = RealLine();
    } else {
      domainUnused = buildSubsetFromMathExpression(domain[0]);
    }
  } else {
    domainUnused = RealLine();
  }
  let effectiveChildDomains = [];
  for (let childDomain of numericalDomainsOfChildren) {
    if (!childDomain) {
      effectiveChildDomains.push(EmptySet());
    } else {
      let childDomainMathExpr = me.fromAst([
        "interval",
        ["tuple", ...childDomain[0]],
        ["tuple", ...childDomain[1]]
      ]);
      let childDomainSubset = buildSubsetFromMathExpression(childDomainMathExpr);
      let childDomainToConsider = childDomainSubset.intersect(domainUnused);
      domainUnused = domainUnused.setMinus(childDomainSubset);
      effectiveChildDomains.push(childDomainToConsider);
    }
  }
  return effectiveChildDomains;
}
const { gcd, lcm } = me.math;
function enumerateSelectionCombinations({
  numberOfIndices,
  numberOfOptions,
  maxNumber = Infinity,
  withReplacement = false,
  skipZero = false
  // for case when generating offsets but without replacement
}) {
  if (numberOfIndices === 1) {
    let options = [...Array(numberOfOptions).keys()];
    options = options.slice(1);
    if (!skipZero) {
      options = [...options, 0];
    }
    options = options.slice(0, maxNumber);
    let options2 = options.map((x2) => [x2]);
    return options2;
  }
  let allOffsetsCombinations = enumerateSelectionCombinations({
    numberOfIndices: numberOfIndices - 1,
    numberOfOptions,
    maxNumber,
    withReplacement,
    skipZero: !withReplacement
  });
  let results = [];
  let numberSoFar = 0;
  for (let offsets of allOffsetsCombinations) {
    for (let ind0 = 1; ind0 <= numberOfOptions; ind0++) {
      let combination = [
        ind0 % numberOfOptions,
        ...offsets.map((x2) => (ind0 + x2) % numberOfOptions)
      ];
      if (skipZero && combination.includes(0)) {
        continue;
      }
      results.push(combination);
      numberSoFar++;
      if (numberSoFar >= maxNumber) {
        return results;
      }
    }
  }
  return results;
}
function enumerateCombinations({
  numberOfOptionsByIndex,
  maxNumber = Infinity
}) {
  let numberOfIndices = numberOfOptionsByIndex.length;
  if (numberOfIndices === 0) {
    return [];
  }
  let gcds = [];
  for (let ind1 = 0; ind1 < numberOfIndices; ind1++) {
    let g2 = [];
    for (let ind2 = 0; ind2 < ind1; ind2++) {
      g2.push(
        gcd(numberOfOptionsByIndex[ind1], numberOfOptionsByIndex[ind2])
      );
    }
    gcds.push(g2);
  }
  let maxGCD = gcds.reduce((a, c) => [...c, ...a], []).reduce((a, c) => Math.max(a, c), 1);
  if (maxGCD === 1) {
    let totalCombinations = numberOfOptionsByIndex.reduce((a, c) => a * c);
    totalCombinations = Math.min(totalCombinations, maxNumber);
    let results = [];
    for (let ind = 0; ind < totalCombinations; ind++) {
      let r = numberOfOptionsByIndex.map((x2) => ind % x2);
      results.push(r);
    }
    return results;
  }
  if (numberOfIndices === 2) {
    const gcdValue = maxGCD;
    let computedLcm = lcm(...numberOfOptionsByIndex);
    let results = [];
    let numberSoFar = 0;
    for (let offset = 0; offset < gcdValue; offset++) {
      for (let ind = 0; ind < computedLcm; ind++) {
        let r = [
          ind % numberOfOptionsByIndex[0],
          (ind + offset) % numberOfOptionsByIndex[1]
        ];
        results.push(r);
        numberSoFar++;
        if (numberSoFar >= maxNumber) {
          return results;
        }
      }
    }
    return results;
  }
  let lcms = [];
  for (let ind1 = 0; ind1 < numberOfIndices; ind1++) {
    let m = [];
    for (let ind2 = 0; ind2 < ind1; ind2++) {
      if (gcds[ind1][ind2] > 1) {
        m.push(
          lcm(
            numberOfOptionsByIndex[ind1],
            numberOfOptionsByIndex[ind2]
          )
        );
      } else {
        m.push(null);
      }
    }
    lcms.push(m);
  }
  let minLCM = lcms.reduce((a, c) => [...c, ...a], []).filter((x2) => x2 !== null).reduce((a, c) => Math.min(a, c), Infinity);
  let matchInds = [];
  for (let ind1 = 0; ind1 < numberOfIndices; ind1++) {
    for (let ind2 = 0; ind2 < ind1; ind2++) {
      if (lcms[ind1][ind2] === minLCM) {
        matchInds = [ind2, ind1];
        break;
      }
    }
    if (matchInds.length > 0) {
      break;
    }
  }
  let n0 = numberOfOptionsByIndex[matchInds[0]];
  let n1 = numberOfOptionsByIndex[matchInds[1]];
  let innerOptions = [n0, n1];
  let outerOptions = [...numberOfOptionsByIndex];
  outerOptions[matchInds[0]] = n0 * n1;
  outerOptions.splice(matchInds[1], 1);
  let outerResult = enumerateCombinations({
    numberOfOptionsByIndex: outerOptions,
    maxNumber
  });
  let innerResult = enumerateCombinations({
    numberOfOptionsByIndex: innerOptions,
    maxNumber
  });
  for (let r of outerResult) {
    let ires = innerResult[r[matchInds[0]]];
    r.splice(matchInds[0], 1, ires[0]);
    r.splice(matchInds[1], 0, ires[1]);
  }
  return outerResult;
}
function enumeratePermutations({
  values,
  maxNumber
}) {
  let result = [];
  const permute = (arr, m = []) => {
    if (arr.length === 0) {
      result.push(m);
    } else {
      for (let i3 = 0; i3 < arr.length; i3++) {
        let curr = arr.slice();
        let next = curr.splice(i3, 1);
        permute(curr.slice(), m.concat(next));
        if (result.length >= maxNumber) {
          return;
        }
      }
    }
  };
  permute(values);
  return result;
}
function normalizeMathExpression({
  value,
  simplify,
  expand = false,
  createVectors = false,
  createIntervals = false,
  assumptions = null
}) {
  if (assumptions && assumptions.tree !== "＿") {
    const assumptionsToAdd = [];
    if (Array.isArray(assumptions.tree) && assumptions.tree[0] === "list") {
      for (let i3 = 1; i3 < assumptions.tree.length; i3++) {
        assumptionsToAdd.push(me.fromAst(assumptions.tree[i3]));
      }
    } else {
      assumptionsToAdd.push(assumptions);
    }
    for (const assumption of assumptionsToAdd) {
      me.add_assumption(assumption);
    }
  }
  if (createVectors) {
    value = value.tuples_to_vectors();
  }
  if (createIntervals) {
    value = value.to_intervals();
  }
  if (expand) {
    value = value.expand();
  }
  if (simplify === "full") {
    value = value.simplify();
  } else if (simplify === "numbers") {
    value = value.evaluate_numbers();
  } else if (simplify === "numberspreserveorder") {
    value = value.evaluate_numbers({ skip_ordering: true });
  } else if (simplify === "normalizeorder") {
    value = value.default_order();
  }
  me.clear_assumptions();
  return value;
}
function convertValueToMathExpression(value) {
  if (value instanceof me.class) {
    return value;
  } else if (typeof value === "number" || typeof value === "string") {
    return me.fromAst(value);
  } else if (isTree(value)) {
    return me.fromAst(value);
  } else {
    return me.fromAst("＿");
  }
}
const vectorOperators = ["vector", "altvector", "tuple"];
const { mod } = me.math;
const { dopri } = me.math;
function createFunctionFromDefinition(fDefinition) {
  if (fDefinition.functionType === "formula") {
    return returnNumericalFunctionFromFormula({
      formula: me.fromAst(fDefinition.formula),
      numInputs: fDefinition.numInputs,
      variables: fDefinition.variables.map((x2) => me.fromAst(x2)),
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => me.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "reevaluatedFormula") {
    let evaluateChildrenToReevaluate = {};
    for (let code in fDefinition.evaluateChildrenToReevaluate) {
      evaluateChildrenToReevaluate[code] = {
        fReevaluate: createFunctionFromDefinition(
          fDefinition.evaluateChildrenToReevaluate[code].fReevaluateDefinition
        ),
        inputMathFs: fDefinition.evaluateChildrenToReevaluate[code].inputMaths.map(
          (x2) => me.fromAst(x2).subscripts_to_strings().f()
        )
      };
    }
    return returnNumericalFunctionFromReevaluatedFormula({
      formulaExpressionWithCodes: me.fromAst(
        fDefinition.formulaExpressionWithCodes
      ),
      evaluateChildrenToReevaluate,
      numInputs: fDefinition.numInputs,
      variables: fDefinition.variables.map((x2) => me.fromAst(x2)),
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => me.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "numericForEvaluate") {
    return returnNumericFunctionForEvaluate({
      numInputs: fDefinition.numInputs,
      numericalfs: fDefinition.fDefinitions.map(
        (fdef) => createFunctionFromDefinition(fdef)
      )
    });
  } else if (fDefinition.functionType === "bezier") {
    return returnBezierFunctions({
      numThroughPoints: fDefinition.numThroughPoints,
      numericalThroughPoints: fDefinition.numericalThroughPoints,
      splineCoeffs: fDefinition.splineCoeffs,
      extrapolateForward: fDefinition.extrapolateForward,
      extrapolateForwardCoeffs: fDefinition.extrapolateForwardCoeffs,
      extrapolateBackward: fDefinition.extrapolateBackward,
      extrapolateBackwardCoeffs: fDefinition.extrapolateBackwardCoeffs,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "interpolated") {
    return returnInterpolatedFunction({
      xs: fDefinition.xs,
      coeffs: fDefinition.coeffs,
      interpolationPoints: fDefinition.interpolationPoints,
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => me.fromAst(x2)) : null
    });
  } else if (fDefinition.functionType === "functionOperator") {
    return returnFunctionOperatorFunction({
      componentType: fDefinition.componentType,
      functionOperatorArguments: fDefinition.functionOperatorArguments,
      operatorComposesWithOriginal: fDefinition.operatorComposesWithOriginal,
      originalFDefinition: fDefinition.originalFDefinition,
      numOutputs: fDefinition.numOutputs,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "ODESolution") {
    return returnODESolutionFunction({
      numDimensions: fDefinition.numDimensions,
      t0: fDefinition.t0,
      x0s: fDefinition.x0s,
      chunkSize: fDefinition.chunkSize,
      tolerance: fDefinition.tolerance,
      numericalRHSfDefinitions: fDefinition.numericalRHSfDefinitions,
      maxIterations: fDefinition.maxIterations,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "piecewise") {
    return returnPiecewiseNumericalFunctionFromChildren({
      numericalFsOfChildren: fDefinition.fDefinitionsOfChildren.map(
        (fDef) => createFunctionFromDefinition(fDef)
      ),
      numericalDomainsOfChildren: fDefinition.numericalDomainsOfChildren,
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => me.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else {
    return () => NaN;
  }
}
function returnNumericalFunctionFromFormula({
  formula,
  numInputs,
  variables,
  domain = null,
  component = 0
}) {
  component = Number(component);
  let formulaIsVectorValued = Array.isArray(formula.tree) && vectorOperators.includes(formula.tree[0]);
  if (formulaIsVectorValued) {
    try {
      formula = formula.get_component(component);
    } catch (e2) {
      return () => NaN;
    }
  } else if (component !== 0) {
    return () => NaN;
  }
  let formula_f;
  try {
    formula_f = formula.subscripts_to_strings().f();
  } catch (e2) {
    return () => NaN;
  }
  if (numInputs === 1) {
    let varString = variables[0].subscripts_to_strings().tree;
    let minx = -Infinity, maxx = Infinity;
    let openMin = false, openMax = false;
    if (domain) {
      let domain0 = domain[0];
      if (domain0 !== void 0) {
        minx = me.fromAst(domain0.tree[1][1]).evaluate_to_constant();
        if (typeof minx !== "number" || Number.isNaN(minx)) {
          minx = -Infinity;
        } else {
          openMin = !domain0.tree[2][1];
        }
        maxx = me.fromAst(domain0.tree[1][2]).evaluate_to_constant();
        if (typeof maxx !== "number" || Number.isNaN(maxx)) {
          maxx = Infinity;
        } else {
          openMax = !domain0.tree[2][2];
        }
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
    }
    return function(x2, overrideDomain = false) {
      if (overrideDomain) {
        if (isNaN(x2)) {
          return NaN;
        }
      } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
        return NaN;
      }
      try {
        return formula_f({ [varString]: x2 });
      } catch (e2) {
        return NaN;
      }
    };
  }
  let varStrings = [];
  for (let i3 = 0; i3 < numInputs; i3++) {
    varStrings.push(variables[i3].subscripts_to_strings().tree);
  }
  let haveDomain = false;
  let domainIntervals = [];
  let domainOpens = [];
  if (domain !== null) {
    haveDomain = true;
    for (let i3 = 0; i3 < numInputs; i3++) {
      let thisDomain = domain[i3];
      if (!thisDomain) {
        haveDomain = false;
        break;
      }
      let minx = -Infinity, maxx = Infinity;
      let openMin = false, openMax = false;
      minx = me.fromAst(thisDomain.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !thisDomain.tree[2][1];
      }
      maxx = me.fromAst(thisDomain.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !thisDomain.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
      domainIntervals.push([minx, maxx]);
      domainOpens.push([openMin, openMax]);
    }
  }
  return function(...xs) {
    let fArgs = {};
    for (let i3 = 0; i3 < numInputs; i3++) {
      let x2 = xs[i3];
      if (isNaN(x2)) {
        return NaN;
      } else if (haveDomain) {
        let [minx, maxx] = domainIntervals[i3];
        let [openMin, openMax] = domainOpens[i3];
        if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
          return NaN;
        }
      }
      fArgs[varStrings[i3]] = x2;
    }
    try {
      return formula_f(fArgs);
    } catch (e2) {
      return NaN;
    }
  };
}
function returnNumericalFunctionFromReevaluatedFormula({
  formulaExpressionWithCodes,
  evaluateChildrenToReevaluate,
  numInputs,
  variables,
  domain = null,
  component = 0
}) {
  component = Number(component);
  let formulaIsVectorValued = Array.isArray(formulaExpressionWithCodes.tree) && vectorOperators.includes(formulaExpressionWithCodes.tree[0]);
  if (formulaIsVectorValued) {
    try {
      formulaExpressionWithCodes = formulaExpressionWithCodes.get_component(Number(component));
    } catch (e2) {
      return () => NaN;
    }
  } else if (component !== 0) {
    return () => NaN;
  }
  let formula_f;
  try {
    formula_f = formulaExpressionWithCodes.subscripts_to_strings().f();
  } catch (e2) {
    return () => NaN;
  }
  if (numInputs === 1) {
    let varString = variables[0].subscripts_to_strings().tree;
    let minx = -Infinity, maxx = Infinity;
    let openMin = false, openMax = false;
    if (domain !== null) {
      let domain0 = domain[0];
      if (domain0 !== void 0) {
        minx = me.fromAst(domain0.tree[1][1]).evaluate_to_constant();
        if (typeof minx !== "number" || Number.isNaN(minx)) {
          minx = -Infinity;
        } else {
          openMin = !domain0.tree[2][1];
        }
        maxx = me.fromAst(domain0.tree[1][2]).evaluate_to_constant();
        if (typeof maxx !== "number" || Number.isNaN(maxx)) {
          maxx = Infinity;
        } else {
          openMax = !domain0.tree[2][2];
        }
      }
    }
    if (minx === -Infinity) {
      openMin = false;
    }
    if (maxx === Infinity) {
      openMax = false;
    }
    return function(x2, overrideDomain = false) {
      if (overrideDomain) {
        if (isNaN(x2)) {
          return NaN;
        }
      } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
        return NaN;
      }
      let argsForInputs = { [varString]: x2 };
      let fArgs = { [varString]: x2 };
      for (let code in evaluateChildrenToReevaluate) {
        let childF = evaluateChildrenToReevaluate[code].fReevaluate;
        let inputFs = evaluateChildrenToReevaluate[code].inputMathFs;
        try {
          let input = inputFs.map(
            (f2) => me.fromAst(f2(argsForInputs))
          );
          fArgs[code] = childF(input).evaluate_to_constant();
        } catch (e2) {
          return NaN;
        }
      }
      try {
        return formula_f(fArgs);
      } catch (e2) {
        return NaN;
      }
    };
  }
  let varStrings = [];
  for (let i3 = 0; i3 < numInputs; i3++) {
    varStrings.push(variables[i3].subscripts_to_strings().tree);
  }
  let haveDomain = false;
  let domainIntervals = [];
  let domainOpens = [];
  if (domain !== null) {
    haveDomain = true;
    for (let i3 = 0; i3 < numInputs; i3++) {
      let thisDomain = domain[i3];
      if (!thisDomain) {
        haveDomain = false;
        break;
      }
      let minx = -Infinity, maxx = Infinity;
      let openMin = false, openMax = false;
      minx = me.fromAst(thisDomain.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !thisDomain.tree[2][1];
      }
      maxx = me.fromAst(thisDomain.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !thisDomain.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
      domainIntervals.push([minx, maxx]);
      domainOpens.push([openMin, openMax]);
    }
  }
  return function(...xs) {
    let fArgs = {};
    for (let i3 = 0; i3 < numInputs; i3++) {
      let x2 = xs[i3];
      if (typeof x2 !== "number" || isNaN(x2)) {
        return NaN;
      } else if (haveDomain) {
        let [minx, maxx] = domainIntervals[i3];
        let [openMin, openMax] = domainOpens[i3];
        if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
          return NaN;
        }
      }
      fArgs[varStrings[i3]] = x2;
    }
    let argsForInputs = { ...fArgs };
    for (let code in evaluateChildrenToReevaluate) {
      let childF = evaluateChildrenToReevaluate[code].fReevaluate;
      let inputFs = evaluateChildrenToReevaluate[code].inputMathFs;
      try {
        let input = inputFs.map(
          (f2) => me.fromAst(f2(argsForInputs))
        );
        fArgs[code] = childF(input).evaluate_to_constant();
      } catch (e2) {
        return NaN;
      }
    }
    try {
      return formula_f(fArgs);
    } catch (e2) {
      return NaN;
    }
  };
}
function returnPiecewiseNumericalFunctionFromChildren({
  numericalFsOfChildren,
  numericalDomainsOfChildren,
  domain = null,
  component = 0
}) {
  component = Number(component);
  if (component !== 0) {
    return () => NaN;
  }
  let { minx, maxx, openMin, openMax } = find_effective_domain({
    domain: domain ?? null
  });
  return function(x2, overrideDomain = false) {
    if (overrideDomain) {
      if (isNaN(x2)) {
        return NaN;
      }
    } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
      return NaN;
    }
    for (let [ind, childDomain] of numericalDomainsOfChildren.entries()) {
      let childMinX = childDomain[0][0];
      let childMaxX = childDomain[0][1];
      let childMinXClosed = childDomain[1][0];
      let childMaxXClosed = childDomain[1][1];
      if ((x2 > childMinX || childMinXClosed && x2 === childMinX) && (x2 < childMaxX || childMaxXClosed && x2 === childMaxX)) {
        return numericalFsOfChildren[ind](x2);
      }
    }
    return NaN;
  };
}
function returnSymbolicFunctionFromFormula({
  formula,
  simplify,
  expand,
  domain = null,
  numInputs,
  variables,
  component = 0
}) {
  component = Number(component);
  let formulaIsVectorValued = Array.isArray(formula.tree) && vectorOperators.includes(formula.tree[0]);
  if (formulaIsVectorValued) {
    try {
      formula = formula.get_component(component);
    } catch (e2) {
      return () => me.fromAst("＿");
    }
  } else if (component !== 0) {
    return () => me.fromAst("＿");
  }
  let formula_transformed = formula.subscripts_to_strings();
  if (numInputs === 1) {
    let varString = variables[0].subscripts_to_strings().tree;
    let minx = -Infinity, maxx = Infinity;
    let openMin = false, openMax = false;
    if (domain !== null) {
      let domain0 = domain[0];
      if (domain0 !== void 0) {
        minx = me.fromAst(domain0.tree[1][1]).evaluate_to_constant();
        if (typeof minx !== "number" || Number.isNaN(minx)) {
          minx = -Infinity;
        } else {
          openMin = !domain0.tree[2][1];
        }
        maxx = me.fromAst(domain0.tree[1][2]).evaluate_to_constant();
        if (typeof maxx !== "number" || Number.isNaN(maxx)) {
          maxx = Infinity;
        } else {
          openMax = !domain0.tree[2][2];
        }
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
    }
    return function(x2, overrideDomain = false) {
      if (!overrideDomain) {
        let xNum = x2.evaluate_to_constant();
        if (!Number.isNaN(xNum) && (!(xNum >= minx) || !(xNum <= maxx) || openMin && xNum === minx || openMax && xNum === maxx)) {
          return me.fromAst("＿");
        }
      }
      return normalizeMathExpression({
        value: formula_transformed.substitute({ [varString]: x2 }).strings_to_subscripts(),
        simplify,
        expand
      });
    };
  }
  let varStrings = [];
  for (let i3 = 0; i3 < numInputs; i3++) {
    varStrings.push(variables[i3].subscripts_to_strings().tree);
  }
  let haveDomain = false;
  let domainIntervals = [];
  let domainOpens = [];
  if (domain !== null) {
    haveDomain = true;
    for (let i3 = 0; i3 < numInputs; i3++) {
      let thisDomain = domain[i3];
      if (!thisDomain) {
        haveDomain = false;
        break;
      }
      let minx = -Infinity, maxx = Infinity;
      let openMin = false, openMax = false;
      minx = me.fromAst(thisDomain.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !thisDomain.tree[2][1];
      }
      maxx = me.fromAst(thisDomain.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !thisDomain.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
      domainIntervals.push([minx, maxx]);
      domainOpens.push([openMin, openMax]);
    }
    if (haveDomain && domainIntervals.every(
      (v2) => v2[0] === -Infinity && v2[1] === Infinity
    )) {
      haveDomain = false;
    }
  }
  return function(...xs) {
    let subArgs = {};
    let foundOutsideDomain = false;
    let allNumeric = true;
    for (let i3 = 0; i3 < numInputs; i3++) {
      let x2 = xs[i3];
      if (haveDomain && allNumeric) {
        let xNum = x2.evaluate_to_constant();
        if (Number.isNaN(xNum)) {
          allNumeric = false;
        } else {
          let [minx, maxx] = domainIntervals[i3];
          let [openMin, openMax] = domainOpens[i3];
          if (!(xNum >= minx) || !(xNum <= maxx) || openMin && xNum === minx || openMax && xNum === maxx) {
            foundOutsideDomain = true;
          }
        }
      }
      subArgs[varStrings[i3]] = x2;
    }
    if (allNumeric && foundOutsideDomain) {
      return me.fromAst("＿");
    }
    return normalizeMathExpression({
      value: formula_transformed.substitute(subArgs).strings_to_subscripts(),
      simplify,
      expand
    });
  };
}
function returnSymbolicFunctionFromReevaluatedFormula({
  formulaExpressionWithCodes,
  evaluateChildrenToReevaluate,
  simplify,
  expand,
  numInputs,
  variables,
  domain = null,
  component = 0
}) {
  component = Number(component);
  let formulaIsVectorValued = Array.isArray(formulaExpressionWithCodes.tree) && vectorOperators.includes(formulaExpressionWithCodes.tree[0]);
  if (formulaIsVectorValued) {
    try {
      formulaExpressionWithCodes = formulaExpressionWithCodes.get_component(component);
    } catch (e2) {
      return () => me.fromAst("＿");
    }
  } else if (component !== 0) {
    return () => me.fromAst("＿");
  }
  let formula_transformed = formulaExpressionWithCodes.subscripts_to_strings();
  if (numInputs === 1) {
    let varString = variables[0].subscripts_to_strings().tree;
    let minx = -Infinity, maxx = Infinity;
    let openMin = false, openMax = false;
    if (domain !== null) {
      let domain0 = domain[0];
      if (domain0 !== void 0) {
        minx = me.fromAst(domain0.tree[1][1]).evaluate_to_constant();
        if (typeof minx !== "number" || Number.isNaN(minx)) {
          minx = -Infinity;
        } else {
          openMin = !domain0.tree[2][1];
        }
        maxx = me.fromAst(domain0.tree[1][2]).evaluate_to_constant();
        if (typeof maxx !== "number" || Number.isNaN(maxx)) {
          maxx = Infinity;
        } else {
          openMax = !domain0.tree[2][2];
        }
        if (minx === -Infinity) {
          openMin = false;
        }
        if (maxx === Infinity) {
          openMax = false;
        }
      }
    }
    return function(x2, overrideDomain = false) {
      if (!overrideDomain) {
        let xNum = x2.evaluate_to_constant();
        if (!Number.isNaN(xNum) && (!(xNum >= minx) || !(xNum <= maxx) || openMin && xNum === minx || openMax && xNum === maxx)) {
          return me.fromAst("＿");
        }
      }
      let argsForInputs = { [varString]: x2.tree };
      let fArgs = { [varString]: x2 };
      for (let code in evaluateChildrenToReevaluate) {
        let childF = evaluateChildrenToReevaluate[code].fReevaluate;
        let inputFs = evaluateChildrenToReevaluate[code].inputMathFs;
        try {
          let input = inputFs.map(
            (f2) => me.fromAst(f2(argsForInputs))
          );
          fArgs[code] = childF(input);
        } catch (e2) {
          return me.fromAst("＿");
        }
      }
      return normalizeMathExpression({
        value: formula_transformed.substitute(fArgs).strings_to_subscripts(),
        simplify,
        expand
      });
    };
  }
  let varStrings = [];
  for (let i3 = 0; i3 < numInputs; i3++) {
    varStrings.push(variables[i3].subscripts_to_strings().tree);
  }
  let haveDomain = false;
  let domainIntervals = [];
  let domainOpens = [];
  if (domain !== null) {
    haveDomain = true;
    for (let i3 = 0; i3 < numInputs; i3++) {
      let thisDomain = domain[i3];
      if (!thisDomain) {
        haveDomain = false;
        break;
      }
      let minx = -Infinity, maxx = Infinity;
      let openMin = false, openMax = false;
      minx = me.fromAst(thisDomain.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !thisDomain.tree[2][1];
      }
      maxx = me.fromAst(thisDomain.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !thisDomain.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
      domainIntervals.push([minx, maxx]);
      domainOpens.push([openMin, openMax]);
    }
  }
  return function(...xs) {
    let subArgs = {};
    let argsForInputs = {};
    let foundOutsideDomain = false;
    let allNumeric = true;
    for (let i3 = 0; i3 < numInputs; i3++) {
      let x2 = xs[i3];
      if (haveDomain && allNumeric) {
        let xNum = x2.evaluate_to_constant();
        if (Number.isNaN(xNum)) {
          allNumeric = false;
        } else {
          let [minx, maxx] = domainIntervals[i3];
          let [openMin, openMax] = domainOpens[i3];
          if (!(xNum >= minx) || !(xNum <= maxx) || openMin && xNum === minx || openMax && xNum === maxx) {
            foundOutsideDomain = true;
          }
        }
      }
      subArgs[varStrings[i3]] = x2;
      argsForInputs[varStrings[i3]] = x2.tree;
    }
    if (allNumeric && foundOutsideDomain) {
      return me.fromAst("＿");
    }
    for (let code in evaluateChildrenToReevaluate) {
      let childF = evaluateChildrenToReevaluate[code].fReevaluate;
      let inputFs = evaluateChildrenToReevaluate[code].inputMathFs;
      try {
        let input = inputFs.map(
          (f2) => me.fromAst(f2(argsForInputs))
        );
        subArgs[code] = childF(input);
      } catch (e2) {
        return NaN;
      }
    }
    return normalizeMathExpression({
      value: formula_transformed.substitute(subArgs).strings_to_subscripts(),
      simplify,
      expand
    });
  };
}
function returnSymbolicFunctionForEvaluate({
  symbolicfs,
  numInputs
}) {
  return function(input) {
    if (input.length === 1) {
      let inputTree = input[0].tree;
      if (Array.isArray(inputTree) && vectorOperators.includes(inputTree[0])) {
        input = inputTree.slice(1).map((x2) => me.fromAst(x2));
      }
    }
    if (input.length !== numInputs) {
      return me.fromAst("＿");
    }
    let components = symbolicfs.map((f2) => f2(...input).tree);
    let value;
    if (components.length === 1) {
      value = me.fromAst(components[0]);
    } else {
      value = me.fromAst(["vector", ...components]);
    }
    return value;
  };
}
function returnNumericFunctionForEvaluate({
  numericalfs,
  numInputs
}) {
  return function(input) {
    if (input.length === 1) {
      let inputTree = input[0].tree;
      if (Array.isArray(inputTree) && vectorOperators.includes(inputTree[0])) {
        input = inputTree.slice(1).map((x2) => me.fromAst(x2));
      }
    }
    if (input.length !== numInputs) {
      return me.fromAst("＿");
    }
    let numericInput = input.map((x2) => x2.evaluate_to_constant());
    let components = numericalfs.map((f2) => f2(...numericInput));
    let value;
    if (components.length === 1) {
      value = me.fromAst(components[0]);
    } else {
      value = me.fromAst(["vector", ...components]);
    }
    return value;
  };
}
function returnBezierFunctions({
  numThroughPoints,
  numericalThroughPoints,
  splineCoeffs,
  extrapolateForward,
  extrapolateForwardCoeffs,
  extrapolateBackward,
  extrapolateBackwardCoeffs,
  component
}) {
  if (numThroughPoints < 1) {
    return () => NaN;
  }
  let len = numThroughPoints - 1;
  let lastPointX = numericalThroughPoints[len][component];
  let cs = splineCoeffs.map((x2) => x2[component]);
  let cB;
  if (extrapolateBackward) {
    cB = extrapolateBackwardCoeffs[component];
  }
  let cF;
  if (extrapolateForward) {
    cF = extrapolateForwardCoeffs[component];
  }
  return function(t2) {
    if (isNaN(t2)) {
      return NaN;
    }
    if (t2 < 0) {
      if (extrapolateBackward) {
        return (cB[2] * t2 + cB[1]) * t2 + cB[0];
      } else {
        return NaN;
      }
    }
    if (t2 >= len) {
      if (extrapolateForward) {
        t2 -= len;
        return (cF[2] * t2 + cF[1]) * t2 + cF[0];
      } else if (t2 === len) {
        return lastPointX;
      } else {
        return NaN;
      }
    }
    let z2 = Math.floor(t2);
    t2 -= z2;
    let c = cs[z2];
    return ((c[3] * t2 + c[2]) * t2 + c[1]) * t2 + c[0];
  };
}
function returnInterpolatedFunction({
  xs,
  coeffs,
  interpolationPoints,
  domain = null
}) {
  let interpolationPointYs = [];
  if (interpolationPoints) {
    interpolationPointYs = interpolationPoints.map((x2) => x2.y);
  }
  if (xs === null) {
    return () => NaN;
  }
  let minx = -Infinity, maxx = Infinity;
  let openMin = false, openMax = false;
  if (domain !== null) {
    let domain0 = domain[0];
    if (domain0 !== void 0) {
      minx = me.fromAst(domain0.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !domain0.tree[2][1];
      }
      maxx = me.fromAst(domain0.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !domain0.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
    }
  }
  let x0 = xs[0], xL = xs[xs.length - 1];
  return function(x2, overrideDomain = false) {
    if (overrideDomain) {
      if (isNaN(x2)) {
        return NaN;
      }
    } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
      return NaN;
    }
    if (x2 <= x0) {
      x2 -= x0;
      let c2 = coeffs[0];
      if (x2 === -Infinity) {
        if (c2[3] === 0) {
          if (c2[2] === 0) {
            if (c2[1] === 0) {
              return c2[0];
            } else {
              return -Math.sign(c2[1]) * Infinity;
            }
          } else {
            return Math.sign(c2[2]) * Infinity;
          }
        } else {
          return -Math.sign(c2[3]) * Infinity;
        }
      }
      return ((c2[3] * x2 + c2[2]) * x2 + c2[1]) * x2 + c2[0];
    }
    if (x2 >= xL) {
      let i22 = xs.length - 2;
      x2 -= xs[i22];
      let c2 = coeffs[i22];
      if (x2 === Infinity) {
        if (c2[3] === 0) {
          if (c2[2] === 0) {
            if (c2[1] === 0) {
              return c2[0];
            } else {
              return Math.sign(c2[1]) * Infinity;
            }
          } else {
            return Math.sign(c2[2]) * Infinity;
          }
        } else {
          return Math.sign(c2[3]) * Infinity;
        }
      }
      if (x2 === Infinity && c2[1] === 0 && c2[2] === 0 && c2[3] === 0) {
        return c2[0];
      }
      return ((c2[3] * x2 + c2[2]) * x2 + c2[1]) * x2 + c2[0];
    }
    let low = 0, mid, high = xs.length - 1;
    while (low <= high) {
      mid = Math.floor(0.5 * (low + high));
      let xHere = xs[mid];
      if (xHere < x2) {
        low = mid + 1;
      } else if (xHere > x2) {
        high = mid - 1;
      } else {
        return interpolationPointYs[mid];
      }
    }
    let i3 = Math.max(0, high);
    x2 -= xs[i3];
    let c = coeffs[i3];
    return ((c[3] * x2 + c[2]) * x2 + c[1]) * x2 + c[0];
  };
}
function returnReturnDerivativesOfInterpolatedFunction({
  xs,
  coeffs,
  variables
}) {
  if (!xs) {
    return () => () => NaN;
  }
  let variable1Trans = variables[0].subscripts_to_strings().tree;
  let x0 = xs[0], xL = xs[xs.length - 1];
  return function(derivVariables) {
    let derivVariablesTrans = derivVariables.map(
      (x2) => x2.subscripts_to_strings().tree
    );
    let order = derivVariablesTrans.length;
    if (order > 3 || !derivVariablesTrans.every((x2) => x2 === variable1Trans) || derivVariablesTrans.includes("＿")) {
      return () => 0;
    }
    if (order === 0 || xs === null) {
      return () => NaN;
    }
    return function(x2) {
      if (isNaN(x2)) {
        return NaN;
      }
      if (x2 <= x0) {
        x2 -= x0;
        let c2 = coeffs[0];
        if (order === 1) {
          return (3 * c2[3] * x2 + 2 * c2[2]) * x2 + c2[1];
        } else if (order === 2) {
          return 6 * c2[3] * x2 + 2 * c2[2];
        } else {
          return 6 * c2[3];
        }
      }
      if (x2 >= xL) {
        let i22 = xs.length - 2;
        x2 -= xs[i22];
        let c2 = coeffs[i22];
        if (order === 1) {
          return (3 * c2[3] * x2 + 2 * c2[2]) * x2 + c2[1];
        } else if (order === 2) {
          return 6 * c2[3] * x2 + 2 * c2[2];
        } else {
          return 6 * c2[3];
        }
      }
      let low = 0, mid, high = xs.length - 1;
      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        let xHere = xs[mid];
        if (xHere < x2) {
          low = mid + 1;
        } else if (xHere > x2) {
          high = mid - 1;
        } else {
          if (order === 1) {
            return coeffs[mid][1];
          } else if (order === 2) {
            return 2 * coeffs[mid][2];
          } else {
            return 6 * coeffs[mid][3];
          }
        }
      }
      let i3 = Math.max(0, high);
      x2 -= xs[i3];
      let c = coeffs[i3];
      if (order === 1) {
        return (3 * c[3] * x2 + 2 * c[2]) * x2 + c[1];
      } else if (order === 2) {
        return 6 * c[3] * x2 + 2 * c[2];
      } else {
        return 6 * c[3];
      }
    };
  };
}
function returnFunctionOperatorFunction({
  componentType,
  functionOperatorArguments,
  operatorComposesWithOriginal,
  originalFDefinition,
  numOutputs,
  component
}) {
  if (operatorComposesWithOriginal) {
    let childFs = [];
    for (let ind = 0; ind < numOutputs; ind++) {
      childFs.push(createFunctionFromDefinition(originalFDefinition));
    }
    let functionOperator = functionOperatorDefinitions[componentType](
      ...functionOperatorArguments
    );
    return (...xs) => functionOperator(...childFs.map((cf) => cf(...xs)));
  } else {
    return functionOperatorDefinitions[componentType](
      ...functionOperatorArguments
    );
  }
}
const functionOperatorDefinitions = {
  clampFunction: function(lowerValue, upperValue) {
    return function(x2) {
      if (!Number.isFinite(x2)) {
        return NaN;
      }
      return Math.max(lowerValue, Math.min(upperValue, x2));
    };
  },
  wrapFunctionPeriodic: function(lowerValue, upperValue) {
    return function(x2) {
      if (!Number.isFinite(x2)) {
        return NaN;
      }
      let lower = lowerValue;
      let upper = upperValue;
      if (lower === upper) {
        return lower;
      }
      if (lower > upper) {
        [upper, lower] = [lower, upper];
      }
      return lower + mod(x2 - lower, upper - lower);
    };
  },
  derivative: function(derivDefinition, derivVariables) {
    if (derivDefinition.derivativeType === "interpolatedFunction") {
      let derivGenerator = returnReturnDerivativesOfInterpolatedFunction({
        xs: derivDefinition.xs,
        coeffs: derivDefinition.coeffs,
        variables: derivDefinition.variables.map(
          convertValueToMathExpression
        )
      });
      let vars = derivVariables.map(convertValueToMathExpression);
      if (derivDefinition.additionalDerivVariables) {
        let additionalVars = derivDefinition.additionalDerivVariables.map(
          convertValueToMathExpression
        );
        vars = [...additionalVars, ...vars];
      }
      if (derivDefinition.variableMappings) {
        for (let variableMapping of derivDefinition.variableMappings) {
          let mappedDerivVariables = [];
          for (let dVar of vars) {
            let mapped = variableMapping[dVar.subscripts_to_strings().tree];
            if (mapped) {
              mappedDerivVariables.push(
                convertValueToMathExpression(mapped)
              );
            } else {
              mappedDerivVariables.push(me.fromAst("＿"));
            }
          }
          vars = mappedDerivVariables;
        }
      }
      let deriv = derivGenerator(vars);
      return deriv;
    } else {
      return () => NaN;
    }
  }
};
function returnODESolutionFunction({
  numDimensions,
  t0,
  x0s,
  chunkSize,
  tolerance,
  numericalRHSfDefinitions,
  maxIterations,
  component
}) {
  let workspace = {
    calculatedNumericSolutions: [],
    endingNumericalValues: [],
    maxPossibleTime: void 0
  };
  workspace.calculatedNumericSolutions = [];
  workspace.endingNumericalValues = [];
  workspace.maxPossibleTime = void 0;
  let numericalRHSfcomponents = numericalRHSfDefinitions.map(
    (x2) => createFunctionFromDefinition(x2)
  );
  let numericalRHSf = function(t2, x2) {
    let fargs = [t2];
    if (Array.isArray(x2)) {
      fargs.push(...x2);
    } else {
      fargs.push(x2);
    }
    try {
      return numericalRHSfcomponents.map((f2) => f2(...fargs));
    } catch (e2) {
      return [NaN];
    }
  };
  return function f2(t2) {
    if (!Number.isFinite(t2)) {
      return NaN;
    }
    if (t2 === t0) {
      return x0s[component];
    }
    let nChunksCalculated = workspace.calculatedNumericSolutions.length;
    let chunk = Math.ceil((t2 - t0) / chunkSize) - 1;
    if (chunk < 0) {
      return NaN;
    }
    if (workspace.maxPossibleTime === void 0 && chunk >= nChunksCalculated) {
      for (let tind = nChunksCalculated; tind <= chunk; tind++) {
        let x0 = workspace.endingNumericalValues[tind - 1];
        if (x0 === void 0) {
          x0 = x0s;
        }
        let t0shifted = t0 + tind * chunkSize;
        let result = dopri(
          t0shifted,
          t0shifted + chunkSize,
          x0,
          numericalRHSf,
          tolerance,
          maxIterations
        );
        workspace.endingNumericalValues.push(
          result.y[result.y.length - 1]
        );
        workspace.calculatedNumericSolutions.push(
          result.at.bind(result)
        );
        let endingTime = result.x[result.x.length - 1];
        if (endingTime < (t0shifted + chunkSize) * (1 - 1e-6)) {
          workspace.maxPossibleTime = endingTime;
          break;
        }
      }
    }
    if (t2 > workspace.maxPossibleTime) {
      return NaN;
    }
    let value = workspace.calculatedNumericSolutions[chunk](t2)[component];
    return value;
  };
}
const creativeCommonsVersions = [
  "1.0",
  "2.0",
  "2.5",
  "3.0",
  "4.0"
];
const defaultCreativeCommonsVersion = "4.0";
function creativeCommonsLicense(code, name, urlSlug, description) {
  return {
    code,
    name: `Creative Commons ${name}`,
    description,
    kind: "creative-commons",
    url: (version = defaultCreativeCommonsVersion) => `https://creativecommons.org/licenses/${urlSlug}/${version}/`
  };
}
function fixedUrlLicense(code, name, url, description, kind) {
  return {
    code,
    name,
    description,
    kind,
    url: () => url
  };
}
const mediaLicenses = [
  creativeCommonsLicense(
    "CC-BY",
    "Attribution",
    "by",
    "Creative Commons Attribution: reuse with credit, including commercially."
  ),
  creativeCommonsLicense(
    "CC-BY-SA",
    "Attribution-ShareAlike",
    "by-sa",
    "Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense(
    "CC-BY-ND",
    "Attribution-NoDerivatives",
    "by-nd",
    "Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit."
  ),
  creativeCommonsLicense(
    "CC-BY-NC",
    "Attribution-NonCommercial",
    "by-nc",
    "Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes."
  ),
  creativeCommonsLicense(
    "CC-BY-NC-SA",
    "Attribution-NonCommercial-ShareAlike",
    "by-nc-sa",
    "Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense(
    "CC-BY-NC-ND",
    "Attribution-NonCommercial-NoDerivatives",
    "by-nc-nd",
    "Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit."
  ),
  fixedUrlLicense(
    "CC0",
    "CC0 1.0 Public Domain Dedication",
    "https://creativecommons.org/publicdomain/zero/1.0/",
    "Creative Commons Zero: the creator has dedicated the work to the public domain.",
    "public-domain"
  ),
  fixedUrlLicense(
    "PDM",
    "Public Domain Mark 1.0",
    "https://creativecommons.org/publicdomain/mark/1.0/",
    "Public Domain Mark: the work is free of known copyright restrictions.",
    "public-domain"
  ),
  fixedUrlLicense(
    "GFDL",
    "GNU Free Documentation License",
    "https://www.gnu.org/licenses/fdl-1.3.html",
    "GNU Free Documentation License: copyleft license common on Wikimedia.",
    "license"
  ),
  fixedUrlLicense(
    "FAL",
    "Free Art License 1.3",
    "https://artlibre.org/licence/lal/en/",
    "Free Art License: copyleft license for artistic works.",
    "license"
  ),
  fixedUrlLicense(
    "OGL",
    "Open Government Licence v3.0 (UK)",
    "https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/",
    "UK Open Government Licence: reuse government material with attribution.",
    "license"
  ),
  fixedUrlLicense(
    "MIT",
    "MIT License",
    "https://opensource.org/license/mit",
    "MIT License: permissive license common for icon and illustration sets.",
    "license"
  ),
  fixedUrlLicense(
    "APACHE-2.0",
    "Apache License 2.0",
    "https://www.apache.org/licenses/LICENSE-2.0",
    "Apache License 2.0: permissive license common for icon and illustration sets.",
    "license"
  )
];
const mediaLicensesByLowerCode = Object.fromEntries(
  mediaLicenses.map((info) => [info.code.toLowerCase(), info])
);
function getMediaLicenseInfo(code) {
  return mediaLicensesByLowerCode[code.toLowerCase()];
}
function getMediaLicenseDisplay(code, version) {
  const info = getMediaLicenseInfo(code);
  if (!info) {
    return void 0;
  }
  const resolvedVersion = version ?? defaultCreativeCommonsVersion;
  const label = info.kind === "creative-commons" ? `${info.name} ${resolvedVersion}` : info.name;
  return { kind: info.kind, label, url: info.url(resolvedVersion) };
}
function lettersToNumber(letters) {
  try {
    letters = letters.toUpperCase();
  } catch (e2) {
    console.warn("Cannot convert " + letters + " to a number");
    return void 0;
  }
  let number = 0, len = letters.length, pos = len;
  while ((pos -= 1) > -1) {
    let numForLetter = letters.charCodeAt(pos) - 64;
    if (numForLetter < 1 || numForLetter > 26) {
      console.warn("Cannot convert " + letters + " to a number");
      return void 0;
    }
    number += numForLetter * Math.pow(26, len - 1 - pos);
  }
  return number;
}
function numberToLetters(number, lowercase) {
  number--;
  let offset = 65;
  if (lowercase) {
    offset = 97;
  }
  let letters = "";
  while (true) {
    let nextNum = number % 26;
    letters = String.fromCharCode(offset + nextNum) + letters;
    if (number < 26) {
      break;
    }
    number = Math.floor(number / 26) - 1;
  }
  return letters;
}
const maxWidth = 850;
const sizePossibilities = ["tiny", "small", "medium", "large", "full"];
const widthFractions = [1 / 12, 0.3, 0.5, 0.7, 1];
const fractionMidpoints = widthFractions.map(
  (x2, i3) => (x2 + (widthFractions[i3 + 1] || Infinity)) / 2
);
const orderedWidthMidpoints = fractionMidpoints.map((x2) => maxWidth * x2);
const orderedPercentWidthMidpoints = fractionMidpoints.map(
  (x2) => x2 * 100
);
const widthsBySize = {};
sizePossibilities.forEach(
  (x2, i3) => widthsBySize[x2] = Math.floor(widthFractions[i3] * maxWidth)
);
const percentWidthsBySize = {};
sizePossibilities.forEach(
  (x2, i3) => percentWidthsBySize[x2] = Math.round(widthFractions[i3] * 100)
);
function flattenDeep(arr1) {
  return arr1.reduce(
    (acc, val) => Array.isArray(val) ? acc.concat(flattenDeep(val)) : acc.concat(val),
    []
  );
}
function flattenLevels(arr1, levels) {
  return arr1.reduce(
    (acc, val) => Array.isArray(val) && levels > 1 ? acc.concat(flattenLevels(val, levels - 1)) : acc.concat(val),
    []
  );
}
function mapDeep(arr, f2, iprefix = [], origArr) {
  if (!origArr) {
    origArr = arr;
  }
  return arr.map(
    (v2, i3) => Array.isArray(v2) ? mapDeep(v2, f2, [...iprefix, i3], origArr) : f2(v2, [...iprefix, i3], origArr)
  );
}
const mathjaxConfig = {
  tex: {
    tags: "ams",
    macros: {
      lt: "<",
      gt: ">",
      amp: "&",
      var: ["\\mathrm{#1}", 1],
      csch: "\\operatorname{csch}",
      sech: "\\operatorname{sech}",
      erf: "\\operatorname{erf}"
    },
    displayMath: [["\\[", "\\]"]]
  },
  output: {
    displayOverflow: "linebreak"
  }
};
function roundForDisplay({
  value,
  dependencyValues
}) {
  let rounded = me.round_numbers_to_precision_plus_decimals(
    value,
    dependencyValues.displayDigits,
    dependencyValues.displayDecimals
  );
  if (dependencyValues.displayDigits > 0 && dependencyValues.displaySmallAsZero > 0) {
    rounded = me.set_small_zero(
      rounded,
      dependencyValues.displaySmallAsZero
    );
  }
  return rounded;
}
const DARK_MODE_QUERY = "(prefers-color-scheme: dark)";
function getSystemTheme() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "light";
  }
  return window.matchMedia(DARK_MODE_QUERY).matches ? "dark" : "light";
}
function subscribeToSystemTheme(onChange) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return () => {
    };
  }
  const mediaQuery = window.matchMedia(DARK_MODE_QUERY);
  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  }
  mediaQuery.addListener(onChange);
  return () => mediaQuery.removeListener(onChange);
}
var cssesc_1;
var hasRequiredCssesc;
function requireCssesc() {
  if (hasRequiredCssesc) return cssesc_1;
  hasRequiredCssesc = 1;
  var object = {};
  var hasOwnProperty = object.hasOwnProperty;
  var merge = function merge2(options, defaults) {
    if (!options) {
      return defaults;
    }
    var result = {};
    for (var key in defaults) {
      result[key] = hasOwnProperty.call(options, key) ? options[key] : defaults[key];
    }
    return result;
  };
  var regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
  var regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
  var regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
  var cssesc2 = function cssesc3(string, options) {
    options = merge(options, cssesc3.options);
    if (options.quotes != "single" && options.quotes != "double") {
      options.quotes = "single";
    }
    var quote = options.quotes == "double" ? '"' : "'";
    var isIdentifier = options.isIdentifier;
    var firstChar = string.charAt(0);
    var output = "";
    var counter = 0;
    var length = string.length;
    while (counter < length) {
      var character = string.charAt(counter++);
      var codePoint = character.charCodeAt();
      var value = void 0;
      if (codePoint < 32 || codePoint > 126) {
        if (codePoint >= 55296 && codePoint <= 56319 && counter < length) {
          var extra = string.charCodeAt(counter++);
          if ((extra & 64512) == 56320) {
            codePoint = ((codePoint & 1023) << 10) + (extra & 1023) + 65536;
          } else {
            counter--;
          }
        }
        value = "\\" + codePoint.toString(16).toUpperCase() + " ";
      } else {
        if (options.escapeEverything) {
          if (regexAnySingleEscape.test(character)) {
            value = "\\" + character;
          } else {
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
          }
        } else if (/[\t\n\f\r\x0B]/.test(character)) {
          value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else if (character == "\\" || !isIdentifier && (character == '"' && quote == character || character == "'" && quote == character) || isIdentifier && regexSingleEscape.test(character)) {
          value = "\\" + character;
        } else {
          value = character;
        }
      }
      output += value;
    }
    if (isIdentifier) {
      if (/^-[-\d]/.test(output)) {
        output = "\\-" + output.slice(1);
      } else if (/\d/.test(firstChar)) {
        output = "\\3" + firstChar + " " + output.slice(1);
      }
    }
    output = output.replace(regexExcessiveSpaces, function($0, $1, $2) {
      if ($1 && $1.length % 2) {
        return $0;
      }
      return ($1 || "") + $2;
    });
    if (!isIdentifier && options.wrap) {
      return quote + output + quote;
    }
    return output;
  };
  cssesc2.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
  };
  cssesc2.version = "3.0.0";
  cssesc_1 = cssesc2;
  return cssesc_1;
}
var cssescExports = requireCssesc();
const cssesc = /* @__PURE__ */ getDefaultExportFromCjs(cssescExports);
function cesc(s) {
  s = cssesc(s, { isIdentifier: true });
  if (s.slice(0, 2) === "\\#") {
    s = s.slice(1);
  }
  return s;
}
const currentVersion = "0.6";
const phaseOutPlan = { 0.6: "summer 2025" };
function returnCurrentMinorVersionNumber() {
  let versionPieces = currentVersion.match(/^(\d+)\.(\d+)/);
  return Math.round(Number(versionPieces[1]) * 10 + Number(versionPieces[2])) / 10;
}
function returnDeprecationMessage(removeInVersion) {
  let versionPhrase = `version ${removeInVersion}`;
  let currentMinorVersion = returnCurrentMinorVersionNumber();
  if (removeInVersion === currentMinorVersion + 0.1) {
    versionPhrase = `the next major version (${removeInVersion})`;
  }
  let phaseOutPhrase = "";
  let phaseOut = phaseOutPlan[currentMinorVersion];
  if (phaseOut) {
    phaseOutPhrase = ` Version ${currentMinorVersion} will be phased out in ${phaseOut}.`;
  }
  return `Its use will become an error in ${versionPhrase}.${phaseOutPhrase}`;
}
const data_format_version = "0.7.0";
export {
  COARSE_POINTER_QUERY,
  D2 as DEFAULT_MATHJAX_SRC,
  DEFAULT_MATH_INPUT_FUNCTION_NAMES,
  D as DEFAULT_PALETTE_NAME,
  d as DEFAULT_STYLE_VALUES,
  S as STYLE_OVERRIDE_CATEGORIES,
  e as STYLE_PALETTES,
  f as STYLE_PALETTE_NAMES,
  g as addMissingChildStyleColorFields,
  h as applyReaderStyleOverrides,
  assignDoenetMLRange,
  i as attributeSpecFromStyleAttribute,
  buildEffectiveMathInputFunctionNames,
  buildSubsetFromMathExpression,
  j as categoricalPalette,
  cesc,
  cidFromArrayBuffer,
  cidFromText,
  aj as codedDiagnostic,
  k as colorValueToWord,
  l as coloredItemsForWords,
  convertDoenetMLAttrRange,
  convertValueToMathExpression,
  createFunctionFromDefinition,
  creativeCommonsVersions,
  currentVersion,
  o as cycleStyleNumberForPalette,
  data_format_version,
  p as decodeFillPatternColorToken,
  deepClone,
  deepCompare,
  defaultCreativeCommonsVersion,
  q as defaultPalette,
  t as deriveMissingStyleWords,
  u as describeBorder,
  v as describeClosedShape,
  w as describeColor,
  x as describeFill,
  y as describeMarker,
  z as describeRegion,
  A as describeStrokedShape,
  B as describeText,
  E as encodeFillPatternColorToken,
  enumerateCombinations,
  enumeratePermutations,
  enumerateSelectionCombinations,
  F as expandStylePalette,
  H as fillOverrideAttributes,
  findAllNewlines,
  find_effective_domain,
  find_effective_domains_piecewise_children,
  flattenDeep,
  flattenLevels,
  functionOperatorDefinitions,
  getLineCharRange,
  getMediaLicenseDisplay,
  getMediaLicenseInfo,
  I as getStylePalette,
  J as getStylePalettes,
  K as getStyleValueNumber,
  L as getStyleValueString,
  getSystemTheme,
  M as grayscalePalette,
  N as grumpyNarwhalPalette,
  hasCoarsePrimaryPointer,
  O as ibmPalette,
  isAccessibilityRecord,
  isErrorRecord,
  isInfoRecord,
  isMacPlatform,
  i2 as isMathJaxEngine,
  isSaveShortcutKeydown,
  Q as isStyleValueWithPosition,
  isValidMathQuillFunctionName,
  isWarningRecord,
  R as latestPosition,
  lettersToNumber,
  U as lineOverrideAttributes,
  l2 as loadMathJax,
  mapDeep,
  V as markerOverrideAttributes,
  W as markerStyleValuesWithFillVariants,
  mathExpressionFromSubsetValue,
  mathjaxConfig,
  mediaLicenses,
  mergeIntervals,
  nanInfinityReviver,
  X as noBackgroundWord,
  normalizeMathExpression,
  Y as normalizeStyleDefinitionValues,
  Z as normalizeStyleDefinitionsValues,
  numberToLetters,
  _ as okabeItoPalette,
  orderedPercentWidthMidpoints,
  orderedWidthMidpoints,
  percentWidthsBySize,
  printDoenetMLrange,
  $ as resolveColorWord,
  a0 as resolveReaderPaletteName,
  a1 as resolveStyleDefinition,
  retrieveTextFileForCid,
  returnBezierFunctions,
  returnCurrentMinorVersionNumber,
  a2 as returnDefaultStyleDefinitions,
  returnDeprecationMessage,
  a3 as returnGraphicalStyleDescriptionDefinitions,
  returnInterpolatedFunction,
  returnNumericFunctionForEvaluate,
  returnNumericalFunctionFromFormula,
  returnNumericalFunctionFromReevaluatedFormula,
  a4 as returnPaletteStyleDefinitions,
  returnPiecewiseNumericalFunctionFromChildren,
  returnReturnDerivativesOfInterpolatedFunction,
  a5 as returnSelectedStyleStateVariableDefinition,
  a6 as returnStyleDefinitionStateVariables,
  returnSymbolicFunctionForEvaluate,
  returnSymbolicFunctionFromFormula,
  returnSymbolicFunctionFromReevaluatedFormula,
  a7 as returnTextStyleDescriptionDefinitions,
  roundForDisplay,
  serializedComponentsReplacer,
  serializedComponentsReviver,
  a8 as setStyleValue,
  sizePossibilities,
  a9 as styleAttributes,
  aa as styleOverrideAttributes,
  subscribeToPrimaryPointerType,
  subscribeToSystemTheme,
  subsetOfReals as subsets,
  ac as textRendererStyle,
  ad as tolBrightPalette,
  ae as tolHighContrastPalette,
  af as tolMutedPalette,
  ag as unwrapStyleDefinition,
  vectorOperators,
  widthFractions,
  widthsBySize
};
//# sourceMappingURL=index.js.map
